import React from 'react'
import styled from 'styled-components'

import { Box, Flex, Text, getPaletteColor, Link } from 'pcln-design-system'

const NavFLex = Flex

const NavText = styled(Text.span)`
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  cursor: pointer;
  &:hover {
    text-decoration-line: underline;
    color: ${getPaletteColor('background.lightest')};
  }
`

const NavLink = styled(Link)`
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  font-size: 20px;
  &:hover {
    text-decoration-line: underline;
    color: ${getPaletteColor('background.lightest')};
  }
`

const MiddleDot = () => (
  <Text.span color='background.lightest' px={1}>
    &#183;
  </Text.span>
)

const parseNavText = (props) => {
  return props.navArray.map((data, index, origArray) => (
    <Box key={`nav-box-${index}`}>
      {props.useLink ? (
        <NavLink
          href={data.href}
          target='_blank'
          data-testid={'imageTile-nav-link'}
          id={`nav-text-${index}`}
          fontSize={3}
          fontWeight='regular'
          color='background.lightest'
          textAlign='center'
        >
          {data.linkTitle}
        </NavLink>
      ) : (
        <NavText
          data-testid={'imageTile-nav-text'}
          id={`nav-text-${index}`}
          fontSize={3}
          fontWeight='regular'
          color='background.lightest'
          textAlign='center'
          onClick={(event) => {
            event.preventDefault()
            if (props.handleNavOnClick) props.handleNavOnClick(data.href)
          }}
        >
          {data.linkTitle}
        </NavText>
      )}
      {origArray.length - index > 1 && <MiddleDot />}
    </Box>
  ))
}

const ImageTileNav = (props) => (
  <NavFLex as='nav' style={{ zIndex: 2 }}>
    {parseNavText(props)}
  </NavFLex>
)

ImageTileNav.displayName = 'ImageTileNav'

export default ImageTileNav
